import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'page-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  @Input()  public alertClass: string = 'alert-outline-warning';
  @Input() public link = '';
  @Input() public message = '';

  public get sizeClass(): string {
    return this.link != '' ? 'col-xs-8' : 'col-xs-12';
  }

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  goToUrl() {
    this.router.navigateByUrl(this.link);
  }

}
